"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateUserRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class UpdateUserRequestDto {}
exports.UpdateUserRequestDto = UpdateUserRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], UpdateUserRequestDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], UpdateUserRequestDto.prototype, "blurredImageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  format: 'binary',
  description: 'Avatar image file (JPEG, JPG, PNG)',
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateUserRequestDto.prototype, "avatar", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Optional JWT from POST /auth/me/photo/verify for the same photo uploaded as avatar. ' + 'When missing or invalid, the avatar still updates but isPhotoVerified becomes false.',
  required: false,
  nullable: true
}), __metadata("design:type", String)], UpdateUserRequestDto.prototype, "photoVerificationToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], UpdateUserRequestDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true,
  description: 'Optional sub-gender; must belong to the selected gender when provided.'
}), __metadata("design:type", Object)], UpdateUserRequestDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Whether to show gender preferences on the profile. Defaults to true.'
}), __metadata("design:type", Boolean)], UpdateUserRequestDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Date of birth in MM-DD-YYYY format'
}), __metadata("design:type", String)], UpdateUserRequestDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], UpdateUserRequestDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [enums_1.Gender],
  enum: enums_1.Gender,
  required: false,
  nullable: true,
  description: 'Array of preferred genders'
}), __metadata("design:type", Array)], UpdateUserRequestDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateUserRequestDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateUserRequestDto.prototype, "publishedAppVersion", void 0);
//# sourceMappingURL=UpdateUserRequest.dto.js.map